import goPageUtil from "@/utils/projectUtil/goPageUtil/goPageUtil";
import projectDictUtil from "@/utils/projectUtil/projectDictUtil/projectDictUtil";
import moment from "moment/moment";


export const getRandomMsgId = () => {
  return moment(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS") + "R" + Math.random().toString().substring(2, 5)
}


export default {
  goPageUtil,
  projectDictUtil,
}
